import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../../components/Hero';
import CallToAction from '../../components/CallToAction';
import '../ProjectPages/ProjectPage.css';

// Import images
import socialHeroImage from '../../assets/images/social.jpg';

const SocialResponsibilityEN = () => {
  return (
    <div className="project-page">
      <Helmet>
        <title>Social Responsibility Projects | ProgenX</title>
        <meta name="description" content="ProgenX's social responsibility projects in education technology. We provide free software and education support to students." />
        <meta name="keywords" content="social responsibility, education support, student projects, free software, social benefit" />
        <meta property="og:title" content="Social Responsibility Projects | ProgenX" />
        <meta property="og:description" content="Social responsibility projects in education technology." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://progenxacademy.com/en/projects/social-responsibility" />
        <link rel="canonical" href="https://progenxacademy.com/en/projects/social-responsibility" />
        <link rel="alternate" hreflang="tr" href="https://progenxacademy.com/projeler/sosyal-sorumluluk" />
        <link rel="alternate" hreflang="en" href="https://progenxacademy.com/en/projects/social-responsibility" />
      </Helmet>

      <Hero 
        title="Social Responsibility Projects" 
        backgroundImage={socialHeroImage}
      />

      <div className="project-content">
        <div className="container">
          <section className="project-overview">
            <h2>Working for Equal Opportunities in Education</h2>
            <p>
              As ProgenX, we believe that technology should be accessible to everyone. 
              That's why we share our knowledge in education technologies with students who will be the technology leaders of the future. 
              By providing free education support to students in disadvantaged regions, we contribute to equal opportunities in education.
            </p>
          </section>

          <section className="project-features">
            <h3>What We Do</h3>
            <div className="features-grid">
              <div className="feature-item">
                <h4>HAVELSAN F5 Project</h4>
                <p>
                  By collaborating with Hatay Naim Atakaş Anatolian High School, we offer our software product 
                  in education technologies to students free of charge. 
                  We track students' success, provide training to teachers, 
                  and provide technical support.
                </p>
              </div>

              <div className="feature-item">
                <h4>Support for Disadvantaged Regions</h4>
                <p>
                  We provide free education content to students in regions with limited access to technology and education opportunities. 
                  We organize training programs for teachers, 
                  provide technology infrastructure support, and offer mentoring services.
                </p>
              </div>

              <div className="feature-item">
                <h4>Technology Training and Workshops</h4>
                <p>
                  We provide training to students in areas such as coding, STEM, artificial intelligence, and robotics. 
                  By organizing workshops, we support students in developing themselves in the technology field.
                </p>
              </div>

              <div className="feature-item">
                <h4>Investment in the Future</h4>
                <p>
                  We plan to collaborate with more schools, establish online education platforms, 
                  and start scholarship programs. We invest in their future by offering internship opportunities to students, 
                  providing career mentoring.
                </p>
              </div>
            </div>
          </section>

          <section className="project-benefits">
            <h3>Impacts of Our Projects</h3>
            <div className="benefits-grid">
              <div className="benefit-item">
                <h4>Equal Opportunity for Every Student</h4>
                <p>By offering free opportunities to students with limited access to technology and education opportunities, 
                we contribute to equal opportunities in education. We help every student discover their potential.</p>
              </div>
              <div className="benefit-item">
                <h4>Raising Future Technology Leaders</h4>
                <p>By providing training to students in the technology field, we support them in developing themselves. 
                Future technology leaders will emerge from today's students.</p>
              </div>
              <div className="benefit-item">
                <h4>Adding Value to Society</h4>
                <p>By using our knowledge in education technologies for the benefit of society, 
                we contribute to social development. We make technology accessible to everyone.</p>
              </div>
              <div className="benefit-item">
                <h4>Long-Term and Sustainable</h4>
                <p>Our social responsibility projects are not one-time, but long-term and 
                sustainable. We create lasting impacts by supporting students' continuous development.</p>
              </div>
            </div>
          </section>
        </div>
      </div>

      <CallToAction 
        title="Let's Work Together for Equal Opportunities in Education"
        subtitle="Help us reach more students by supporting our social responsibility projects."
        buttonText="Contact Us" 
        buttonLink="/en/contact" 
      />
    </div>
  );
};

export default SocialResponsibilityEN;
